import { useNavigate } from 'react-router'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../Modal'
import { useCallback } from 'react'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import { ModalConflictColumn } from './types'
import NullComponent from '../../NullComponent'

interface ModalOrderIncompatiblesProps extends ModalOrderIncompatiblesLogicProps {
    textConflict: string
    columns: ModalConflictColumn[]
    incompatibles?: TwinDictionary
}

const ModalOrderIncompatibles: React.FC<ModalOrderIncompatiblesProps> = ({ incompatibles, textConflict, columns, ...logic}) => {
    const {t} = useTwinTranslation()
    const { returnBack } = useModalOrderIncompatiblesLogic({...logic})
    let Element: React.FC<any> = NullComponent
    let field = Object.keys(incompatibles|| {})?.[0]
    for (const key in columns) {
        let column = columns[key] as any
        if (field === column.dataKey) {
            Element = column?.customRender
        }
    }
    return (
        <ModalSmallCentered opened={Object.keys(incompatibles || {})?.length ? true : null} setOpened={() => undefined}>
            <h2 className='mb-10 inline-block'>{textConflict}</h2>
            <Element  />
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={() => undefined} onCancel={returnBack} onAccept={returnBack}  />
        </ModalSmallCentered>
    )
}

interface ModalOrderIncompatiblesLogicProps {
    urlNavigate: string
    returnId: string
}

const useModalOrderIncompatiblesLogic = ({urlNavigate, returnId}: ModalOrderIncompatiblesLogicProps) => {
    const navigate = useNavigate()
    const returnBack = useCallback(() => {
        navigate(urlNavigate + '/' + returnId)
    }, [navigate, returnId, urlNavigate])

    return { returnBack }
}


export default ModalOrderIncompatibles